module.exports = __webpack_public_path__ + "img/gawb.d0289dc0.png";